import { render, staticRenderFns } from "./type-list.vue?vue&type=template&id=6c6969b5&scoped=true&"
import script from "./type-list.vue?vue&type=script&lang=js&"
export * from "./type-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6969b5",
  null
  
)

export default component.exports